import { __assign, __rest } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { arrowsHidden } from '../../utils/cssUtils';
import { InputGroups } from '../InputGroups';
import { areDateStringsValid, dateToStrings, stringsToDate, } from '../InputGroupsWithDatePicker.utils';
export var DateInput = styled(function (_a) {
    var groups = _a.groups, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["groups", "value", "onChange"]);
    var _b = React.useState(dateToStrings(value, groups)), strings = _b[0], setStrings = _b[1];
    React.useEffect(function () {
        setStrings(dateToStrings(value, groups));
    }, [value, groups]);
    return (React.createElement(InputGroups, __assign({ type: "number", inputMode: "numeric", groups: groups.map(function (_a) {
            var dateRole = _a.dateRole, groupProps = __rest(_a, ["dateRole"]);
            return (__assign({}, groupProps));
        }) }, props, { value: strings, onChange: function (_e, newValue) {
            var dateStrings = newValue;
            setStrings(dateStrings);
            if (areDateStringsValid(dateStrings, groups)) {
                onChange(stringsToDate(dateStrings, groups));
            }
        } })));
})(function () { return arrowsHidden; });
//# sourceMappingURL=DateInput.js.map